<template lang='pug'>
  v-container(pa-0='' )
      v-snackbar(v-model='show' color='red' center top :timeout="4000")
        | Invalid format
        v-btn(dark='' text='' @click='show = false')
          | Close
      v-form(ref="form"  v-model="valid")
          v-row(style='display;flex; flex-direction:row; flex-wrap: wrap;')
              v-col(cols="12" md="6")
                  input.d-none(ref="file" type="file" @change="onChange" accept='image/*')
                  v-card.mx-auto.mt-0.d-inline-flex.v-card--account(:class="model.image ? 'success--text' : 'grey--text'" outlined="" height="106" width="106" @click="$refs.file.click()")
                      v-img(v-if='model.image' :src="model.image" height="100%" width="100%")
                      v-icon.mx-auto(v-else="" size="96")
                          | mdi-account
                  .font-weight-bold.grey--text
                      | Subir imagen de perfil
                  v-select.mt-4(:items='roles', label='Rol', :rules='rolRules' ,v-model='model.role' @change="resetForm")
                  v-select(:disabled="!model.role" v-model="permissions" :items='permissionsOpts' return-object item-text="name" label='Permisos' multiple small-chips)
                  //- v-row.text-center.d-flex.justify-center
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.sales" label="Ventas")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.orders" label="Ordenes")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.purchases" label="Compras")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.transfers" label="Transferencias")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.expenses" label="Gastos")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.returns" label="Devoluciones")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions['add-inventory']" label="Importar inventario")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.logs" label="Bitacora")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.inventory" label="Cambio de inventario")
                    v-col.pa-0(cols="4")
                      v-checkbox( v-model="model.permissions.summary" label="Resumen general")
              v-col(cols="12" md="6")
                v-text-field(v-model='model.displayName', :counter='30', :rules='nameRules', label='Nombre', required='')
                v-text-field(v-model='model.email' type='email' :rules='emailRules' label='Email' required='' :disabled='field.types === "update"')
                v-text-field(v-model='model.password' type='password' :rules='pswRules' label='Contraseña' required='' :disabled='field.types === "update"')
                v-select(v-if="model.role === 'Vendedor'"
                    :items="shops"
                    name="shop"
                    label="Seleciona una tienda"
                    v-model="model.shops"
                    item-text="name"
                    item-value="id"
                    multiple
                    chips,
                    required,
                    :rules='shopRules')
          v-btn(@click="cancel()") Cancelar
          v-btn(color='#008e95', @click='validate' :loading="isLoading" :disabled='validForm()')
              | GUARDAR

</template>
<script>
  import firebase from 'firebase'
  import imageCompression from 'browser-image-compression'
  export default {
    props: {
      model: Object,
      field: Object,
      onSave: {
        type: Function,
        required: true,
      },
    },
    data () {
      return {
        valid: true,
        valueType: '',
        show: false,
        isMobile: false,
        nameRules: [
          v => !!v || 'Nombre requerido',
          v => (v && v.length <= 30) || 'Nombre menor a 30 caracteres',
        ],
        emailRules: [
          v => !!v || 'email requerido',
          v => /.+@.+\..+/.test(v) || 'email invalido',
        ],
        pswRules: [
          v => !!v || 'Contraseña requerida',
        ],
        rolRules: [
          v => !!v || 'Rol requerido',
        ],
        shopRules: [
          v => !!v || 'Tienda requerida',
        ],
        roles: ['Colaborador', 'Vendedor'],
        permissions: [],
        /* { name: 'Ventas', type: 'sales' },
        { name: 'Ordenes', type: 'orders' },
        { name: 'Compras', type: 'purchases' },
        { name: 'Transferencias', type: 'transfers' },
        { name: 'Gastos', type: 'expenses' },
        { name: 'Devoluciones', type: 'returns' },
        { name: 'Importar inventario', type: 'add-inventory' },
        { name: 'Bitacora', type: 'logs' },
        { name: 'Cambio de inventario', type: 'inventory' },
        { name: 'Resumen general', type: 'summary' }, */
      }
    },
    computed: {

      user () {
        return this.$store.state.users.user
      },
      shops () {
        return this.$store.getters['shops/getItems']
      },
      isLoading () {
        return this.$store.getters['admins/getLoading']
      },
      permissionsOpts () {
        let opts = [{ name: 'Ventas', type: 'sales' }, { name: 'Ordenes', type: 'orders' }, { name: 'Compras', type: 'purchases' }]
        if (this.model.role === 'Colaborador') {
          opts = opts.concat([
            { name: 'Transferencias', type: 'transfers' },
            { name: 'Gastos', type: 'expenses' },
            { name: 'Devoluciones', type: 'returns' },
            { name: 'Importar inventario', type: 'add-inventory' },
            { name: 'Bitacora', type: 'logs' },
            { name: 'Cambio de inventario', type: 'inventory' },
            { name: 'Resumen general', type: 'summary' },
          ])
        }
        return opts
      },

    },
    mounted () {
      const vm = this
      for (const permissionUser of Object.keys(vm.model.permissions)) {
        if (vm.model.permissions[permissionUser]) {
          vm.permissions.push(vm.permissionsOpts.find(element => element.type === permissionUser))
        }
      }
    },
    beforeUnmounted () {
      console.log('aqui')
    },
    methods: {
      validForm () {
        const vm = this
        if (!vm.model.displayName || !vm.model.role || (vm.model.role === 'Vendedor' && vm.model.shops.length === 0) || vm.permissions.length === 0) {
          return true
        } else {
          return false
        }
      },
      async onChange (val) {
        const vm = this
        const value = val.target.files[0]

        if (!value) return (this.model.image = null)

        this.model.image = URL.createObjectURL(value)

        const imageFile = val.target.files[0]
        // console.log('originalFile instanceof Blob', imageFile instanceof Blob) // true
        // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`)

        const options = {
          maxSizeMB: 0.020,
          maxWidthOrHeight: 120,
          useWebWorker: true,
          maxIteration: 15,
        }
        try {
          const compressedFile = await imageCompression(imageFile, options)
          // console.log('compressedFile instanceof Blob', compressedFile instanceof Blob) // true
          // console.log(`compressedFile size ${compressedFile.size / 1024 / 1024} MB`) // smaller than maxSizeMB
          if (imageFile.size > compressedFile.size) {
            // console.log('compressed is smaller')
            await vm.uploadToServer(compressedFile)
          } else {
            // console.log('original is smaller')
            await vm.uploadToServer(imageFile)
          } // if original is smaller
        } catch (error) {
          // console.log(error)
        }
      },
      uploadToServer (file) {
        const vm = this
        const storageRef = firebase.storage().ref()
        const metadata = {
          contentType: file.type,
          customMetadata: {
            targetType: file.type,
            targetId: vm.user.uid,
            targetName: file.name,
          },
        }
        // Push to child path.
        // [START oncomplete]
        storageRef.child(`users/${vm.user.uid}/profile/picture`).put(file, metadata).then(function (snapshot) {
          snapshot.ref.getDownloadURL().then(function (url) {
            vm.model.image = url
            vm.$forceUpdate()
          })
        }).catch(function (error) {
          console.error('Upload failed:', error)
        })
      },
      async validate () {
        const vm = this
        for await (const permissionUser of Object.keys(vm.model.permissions)) {
          vm.model.permissions[permissionUser] = vm.permissions.some(permission => permission.type === permissionUser)
        }
        vm.$store.commit('admins/SET_LOADING', true)
        if (vm.field.types !== 'update') {
          if (vm.$refs.form.validate()) {
            vm.save()
            vm.snackbar = true
          } else {
            vm.$store.commit('admins/SET_LOADING', false)
            vm.show = true
            vm.isLoading = false
          }
        } else {
          vm.save()
        }
      },
      cancel () {
        this.$emit('cancel')
      },
      save () {
        this.onSave()
      },
      resetForm () {
        const vm = this
        vm.model.shops = []
        vm.permissions = []
      },
    },
  }
</script>
<style scoped lang="scss">
    $break-large: 1200px;
    $primary-color: #c29f52;
    .grid-picker{
        text-align: center;
        min-width: 100%;
        display: grid;
        position: relative;
        flex: 1;
        width: 100%;
        grid-template-areas:

                'picture picture '
                'title title '
                'button button';
        @media screen and (min-width: $break-large) {
            grid-template-areas:

                    'title picture picture '
                    'title picture picture '
                    'button button button';
            .image-slot{
                min-width: 400px;
                height: 250px;
                overflow: hidden;
            }
        }

        grid-gap: 10px;

        padding: 10px;
        .picker-btn{

            grid-area: button;
            flex: 1;
            height: 50px;
        }
        .image-slot{
            margin-left: auto;
            margin-right: auto;
            width: 100%;
            display: flex;
            grid-area: picture;
            max-width: 350px;
            max-height: 250px;
            background: #9e9e9e;
            align-items:center;
            justify-content: center;

        }
    }

    .phone-screen{

        background: url("/img/phone.png");
        display:flex;
        flex-direction: column;
        border-radius: 50px;
        border: 1px solid black;

        min-width: 379px;
        min-height: 736px;
        background-size:  379px 736px;
        background-repeat: no-repeat;
        margin:auto;
        overflow: hidden;
        &__content{

            overflow-y: auto;
            max-width: 382px;
            max-height: 595px;
            margin: auto !important;
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            padding: 0 15px;
        }
    }
    .main-carousel{
        position: relative;
        &__overlay{
            position: absolute;
            bottom:0;
            left:0;
            right:0;
            height: 45px;
            width: 100%;
            margin: auto !important;
            background:rgba(#000,0.5);
            color: #fff;
            text-align: center;

        }
    }
    .property-values{
        border: 1px solid #c29f52;
        border-radius: 30px;
        height: auto;
        padding: 0 10px;
        h3{
            color:#c29f52;
            font-weight: 900;

        }
        .price-tooltip{
            color:#c29f52;
            font-weight: bold;
            margin:auto;
            margin-top:-10px;
            max-width: 100px;
            border: 1px solid #c29f52;
            border-radius: 15px;
            border-top-right-radius: 0;
            border-top-left-radius: 0;
            border-top: none;
        }
    }
    .numPayments{
        background: white !important;
        border: 1px solid #777;
        border-radius: 25px;
        width:auto;
        max-width: fit-content;

        &__button{
            color:#000 !important;
            border-radius: 40px;
        }
    }
    .v-input--slider{
        margin-top:0;
    }
    .v-tabs__container{
        max-width: 100%;
        overflow-x: auto;

    }
    .property-sections{
        span,b{
            font-size: 15px !important;
        }

        .v-tab{
            color: black !important;
        }
    }
    .property-toolbar{

    }
</style>
